module.exports = __webpack_public_path__ + "img/icon_auto.799b2a6c.png";